









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Box extends Vue {
  @Prop({ type: String, default: null }) title: string
  @Prop({ type: Number, default: null }) index: number
  @Prop({ type: String, default: null }) tag: string
  @Prop({ type: String, default: 'is-primary' }) type: string
  @Prop({ type: Boolean, default: false }) paddingless: boolean
}
